// 微信授权相关的工具函数

// 检查微信授权状态
export function checkWechatAuth() {
  const authInfo = localStorage.getItem('wechat_auth_info');
  if (!authInfo) {
    return false;
  }
  
  try {
    const parsedAuthInfo = JSON.parse(authInfo);
    // 检查授权是否有效（24小时有效期）
    const now = new Date().getTime();
    const authTime = parsedAuthInfo.timestamp || 0;
    const expireTime = 24 * 60 * 60 * 1000; // 24小时
    
    return parsedAuthInfo.authorized && (now - authTime < expireTime);
  } catch (error) {
    console.error('解析授权信息失败:', error);
    return false;
  }
}

// 获取微信用户信息
// 注意：由于不再调用getWechatUserInfo接口，此函数将返回null
// 用户信息现在存储在oauthData中，可以通过getWechatOauthData获取
export function getWechatUserInfo() {
  // 由于不再调用获取用户信息接口，直接返回null
  // 如果需要用户信息，可以从oauthData中获取
  const oauthData = getWechatOauthData();
  return oauthData && oauthData.userInfo ? oauthData.userInfo : null;
}

// 获取微信授权code
export function getWechatAuthCode() {
  const authInfo = localStorage.getItem('wechat_auth_info');
  if (!authInfo) {
    return null;
  }
  
  try {
    const parsedAuthInfo = JSON.parse(authInfo);
    return parsedAuthInfo.code || null;
  } catch (error) {
    console.error('获取授权code失败:', error);
    return null;
  }
}

// 获取OAuth数据
export function getWechatOauthData() {
  const authInfo = localStorage.getItem('wechat_auth_info');
  if (!authInfo) {
    return null;
  }
  
  try {
    const parsedAuthInfo = JSON.parse(authInfo);
    return parsedAuthInfo.oauthData || null;
  } catch (error) {
    console.error('获取OAuth数据失败:', error);
    return null;
  }
}

// 清除微信授权信息
export function clearWechatAuth() {
  localStorage.removeItem('wechat_auth_info');
}

// 跳转到微信授权页面
export function redirectToWechatAuth(targetUrl = '') {
  const state = targetUrl ? encodeURIComponent(targetUrl) : 'auth';
  const redirectUri = encodeURIComponent(`${window.location.origin}/h5/wechat-auth`);
  const appId = 'wxa983468b8688ad52';
  
  const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`;
  
  window.location.href = authUrl;
}

// 检查是否在微信环境中
export function isWechatBrowser() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('micromessenger');
}